import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  tooltipContainer: {
    position: 'relative',
    display: 'inline-block'
  },
  '@keyframes animateIn': {
    from: {
      transform: 'translate(0px, -50px)',
      opacity: 0
    },
    to: {
      transform: 'translate(0px, -70px)',
      opacity: 1
    }
  },
  tooltip: {
    left: 0,
    padding: '0.7rem',
    zIndex: 1000,
    position: 'absolute',
    color: '#ffffff',
    background: '#000000',
    boxShadow: '2px 2px 20px 0px rgb(0 0 0 / 9%)',
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    fontWeight: 400,
    fontSize: 13,
    width: 'fit-content',
    maxWidth: 300,
    opacity: 0,
    animationName: '$animateIn',
    animationDelay: '0.4s',
    animationDuration: '0.3s',
    animationFillMode: 'forwards'
  }
}));

type Props = {
  text?: string;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

function Tooltip({
  text,
  children,
  className,
  onMouseEnter,
  onMouseLeave,
  ...props
}: Props) {
  const classes = useStyles();
  const [showTooltip, setShowTooltip] = React.useState<boolean>(false);

  if (!text) {
    return <>{children}</>;
  }

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    setShowTooltip(true);
    onMouseEnter?.(e);
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    setShowTooltip(false);
    onMouseLeave?.(e);
  };

  return (
    <div
      className={`${classes.tooltipContainer} ${className || ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      {children}
      {showTooltip && <div className={classes.tooltip}>{text}</div>}
    </div>
  );
}

export default Tooltip;
